// extracted by mini-css-extract-plugin
export default {"card":"MobileNavBarAccountCard_card__fATY1","cardHeader":"MobileNavBarAccountCard_cardHeader__gjGjk","dropdownHeading":"MobileNavBarAccountCard_dropdownHeading__m9fxr"};